import { FC, useState } from 'react';
import Image from 'next/image';
import MylerCover from 'blocks/MylerSection/assets/myler-cover.jpeg';
import Navigation from './components/Navigation';
import About from './components/About';
import Why from './components/Why';
import Resources from './components/Resources';
import Enquire from './components/Enquire';
import Testimonials from './components/Testimonials';
import Faq from './components/Faq';
import Hotels from './components/Hotels';
import EnquiryForm from './enquiry-form/EnquiryFormContainer';
import InfoDialog from './components/InfoDialog';
import { Heading } from 'components/text';
import VideoPlayer from './components/video-player';
import { useMediaQuery } from '@mui/material';

const MylerSection: FC<{}> = () => {
  const [openForm, setOpenForm] = useState(false);
  const [openInfoForm, setOpenInfoForm] = useState(false);

  const isMobile = useMediaQuery('(max-width: 768px)');

  const scrollToPageSection = (id: string) => {
    const section = document.getElementById(id);
    if (!section) return;

    section?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  };

  const handleOpenEnquiryForm = () => {
    setOpenForm(true);
  };

  return (
    <div className="myler-section-container">
      <div className="myler-section-coverContainer">
        <Image src={MylerCover} alt="Myler discover page main cover" />
      </div>
      <div className="myler-section-overlay">
        <Heading as="h1" className="myler-section-mainHeading" color="white">
          Discover MyLER
        </Heading>
        <Heading as="h2" className="myler-section-subHeading" color="white">
          The future of the Independent Travel Agent
        </Heading>
      </div>
      <Navigation scrollToSection={scrollToPageSection} />
      <About />
      <VideoPlayer
        src="https://d13bre0qp8legl.cloudfront.net/videos/myler-hero.mov"
        muted
        autoPlay
        isMobile={isMobile}
      />
      <Why handleOpenEnquiryForm={handleOpenEnquiryForm} />
      <Resources />
      <Hotels />
      <div className="enquire-testimonial">
        <Enquire handleOpenEnquiryForm={handleOpenEnquiryForm} />
        <Testimonials />
      </div>
      <Faq handleOpenEnquiryForm={handleOpenEnquiryForm} />

      <EnquiryForm
        open={openForm}
        handleFormClose={() => setOpenForm(false)}
        onSubmitSuccess={() => {
          setOpenInfoForm(true);
        }}
      />

      <InfoDialog
        open={openInfoForm}
        title="Thank you"
        subHeading="Your enquiry has been sent"
        handleClose={() => {
          setOpenInfoForm(false);
        }}
      />
    </div>
  );
};

export default MylerSection;
